import { useQuery } from '@apollo/client';
import { useContext } from 'react';

import { Box } from '@uptime/design-system/components/Box';
import { Divider } from '@uptime/design-system/components/Divider';
import { Sidebar as DesignSystemSidebar } from '@uptime/design-system/components/Sidebar';
import { Toolbar } from '@uptime/design-system/components/Toolbar';
import { ThemeProviderV7 } from '@uptime/design-system/MUIv7Exports';
import { DRAWER_WIDTH } from '@uptime/shared/constants';
import { UIContext } from '@uptime/shared/providers/UIProvider';

import useAuth from '@/common/hooks/useAuth';
import { getWhiteLabel } from '@/graphql/queries/user';

import SidebarList from './SidebarList';

const Sidebar = () => {
  const { sidebarIsOpen, setSidebarIsOpen } = useContext(UIContext);
  const { accountId } = useAuth();
  const closeSidebar = () => setSidebarIsOpen(false);

  const { data } = useQuery(getWhiteLabel, {
    variables: { accountId },
    skip: !accountId,
  });

  return (
    <ThemeProviderV7>
      <DesignSystemSidebar width={DRAWER_WIDTH} open={sidebarIsOpen} onSidebarClose={closeSidebar}>
        <Box>
          <Toolbar>
            <Box mt={2} mb={1} width="100%">
              {data?.whiteLabel?.logoUrl && (
                <Box
                  component="a"
                  href={data.whiteLabel.site}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ display: 'block' }}
                >
                  <Box
                    component="img"
                    src={data.whiteLabel.logoUrl}
                    alt="Partner logo"
                    sx={{ maxWidth: '100%', maxHeight: 48 }}
                  />
                </Box>
              )}
            </Box>
          </Toolbar>
          <Box sx={{ px: 1.5 }}>
            <Divider />
          </Box>
          <Box sx={{ height: '100%', overflowY: 'auto' }}>
            <SidebarList onNavigate={closeSidebar} />
          </Box>
        </Box>
      </DesignSystemSidebar>
    </ThemeProviderV7>
  );
};

export default Sidebar;
